import { render, staticRenderFns } from "./indextwo.vue?vue&type=template&id=634724f1&scoped=true&"
import script from "./indextwo.vue?vue&type=script&lang=js&"
export * from "./indextwo.vue?vue&type=script&lang=js&"
import style0 from "./indextwo.vue?vue&type=style&index=0&id=634724f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634724f1",
  null
  
)

export default component.exports